<template>
    <div class="table-head head-fixed waiting-fixed">
        <div class="table-tr">
            <div class="table-th cell-length">{{ __("Patient") }}</div>
            <div class="table-th cell-invite">{{ __("Inactive since") }}</div>
            <div class="table-th cell-therapist">{{ __("Physician") }}</div>
            <div v-if="phase === 'inactive_connected'" class="table-th cell-therapist">{{ __("[m] Dietitian") }}</div>
            <div v-if="phase === 'inactive_connected'" class="table-th cell-call">{{ __("[m] Calls with the dietitian") }}</div>
            <div class="table-th cell-institution width-double">{{ __("Institution") }}</div>
        </div>
    </div>
</template>

<script>
import TableHeader from '@components/PatientsMatrix/TableHeader'

export default {
    extends: TableHeader,
    props: {
        phase: {
            type: String,
            required: false
        }
    }
}
</script>
